///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { MatDialogConfig } from '@angular/material/dialog';

export const EMAIL_VERIFICATION_API = {
    GENERATION: 'api/verification/generation',
    VALIDATION: 'api/verification/validation'
} as const;

export const EMAIL_VERIFICATION_CONSTANTS = {
    BROADCAST_CHANNEL_NAME: 'emailVerification',
    EMAIL_VERIFIED: 'emailVerified',
    TOKEN_PARAM_NAME: 'token',
    CLOSE_DELAY: 2000,
    DIALOG_CONFIG: {
        width: '600px',
        height: '555px',
        position: { top: '30px' },
        disableClose: true
    } as MatDialogConfig
} as const;
